import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconGold: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="gold, goldbars"><path d="M1.75 18.25L3.85 11.5H10.15L12.25 18.25H1.75Z" stroke="currentColor" strokeWidth="1.5"/><path d="M6.75 11.5L8.85 4.75H15.15L17.25 11.5H6.75Z" stroke="currentColor" strokeWidth="1.5"/><path d="M11.75 18.25L13.85 11.5H20.15L22.25 18.25H11.75Z" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconGold;
